import InternalAPI from "../../../../../app/axios.js"
import "../types"

/** @borrows InternalAPI */
export default class DivisionRepository extends InternalAPI {
    constructor() {
        super();
        /** @type {string} */
        this.endpoint = "/v1/division"
    }

    /**
     *
     * @param queries
     * @return {Promise<{data, err: null}|{data: *[], err: string}|{data: null, err: *}>}
     */
    async getAll(queries) {
        try {
            const res = await this.$axios.get(this.endpoint + "/data?" + queries)
            if (res.status === 200) {
                return {data: res.data.data, err: null}
            }
            return {data: [], err: "something went wrong"}
        } catch (err) {
            return {data: null, err: this.setErrorMessage(err.response)}
        }
    }
    
    /**
     *
     * @param id {number}
     * @return {Promise<{data: Division, err: null}|{data: null, err: ErrorState}>}
     */
    async getOne(id) {
        try {
            /** @type {AxiosResponse<Object>} */
            const res = await this.$axios.get(this.endpoint + "/data/" + id);
            if (res.status === 200) {
                if (res.data) {
                    return {data: res.data, err: null}
                }
            }
            return {data: null, err: null}
        } catch (err) {
            return {data: null, err: this.setErrorMessage(err.response)}
        }
    }

    /**
     * 
     * @param id {number}
     * @param formData {FormData}
     * @return {Promise<{err: *}|{err: string}|{err: null}>}
     */
    async editOne(id, formData) {
        try {
            /** @type {AxiosResponse<Object>}*/
            const res = await this.$axios.put(this.endpoint + "/" + id, formData)
            if (res.status === 201 || res.status === 200) {
                return {err: null}
            }
            return {err: "something went wrong"}
        } catch (err) {
            return {err: this.setErrorMessage(err.response)}
        }
    }

    /**
     *
     * @param formData {FormData}
     * @return {Promise<{err: *}|{err: string}|{err: null}>}
     */
    async saveOne(formData) {
        try {
            /** @type {AxiosResponse<Object>}*/
            const res = await this.$axios.post(this.endpoint, formData)
            if (res.status === 201 || res.status === 200) {
                return {err: null}
            }
            return {err: "something went wrong"}
        } catch (err) {
            return {err: this.setErrorMessage(err.response)}
        }
    }
}
